import { onboardingReducer } from './reducer';
import { createStore, applyMiddleware, compose } from 'redux';

// [AI GENERATED CODE] - Resolve redux-thunk with an inline fallback.
// In some CI/test environments, require('redux-thunk') can return undefined or a non-function
// due to CJS/ESM interop or stripped devDependencies. The inline implementation is identical
// to redux-thunk v2.x core behaviour (no withExtraArgument needed by this store).
const _thunkMod = require('redux-thunk');
const thunk = (typeof _thunkMod === 'function')
  ? _thunkMod
  : (typeof (_thunkMod && _thunkMod.default) === 'function')
    ? _thunkMod.default
    : (({ dispatch, getState }) => next => action =>
        typeof action === 'function' ? action(dispatch, getState) : next(action));

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

// [AI GENERATED CODE] - Simplified createStore call: pass enhancer directly instead of
// wrapping in an intermediate function (which caused a shadowed-variable naming ambiguity).
export const createReduxStore = createStore(
  onboardingReducer,
  composeEnhancers(applyMiddleware(thunk))
);
